import DayPickerSelectedDay from './DayPickerSelectedDay';

export default DayPickerSelectedDay;
